import { render, staticRenderFns } from "./3dViewer2.vue?vue&type=template&id=f0ab4e8c&"
import script from "./3dViewer2.vue?vue&type=script&lang=js&"
export * from "./3dViewer2.vue?vue&type=script&lang=js&"
import style0 from "./3dViewer2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports